import { createElement } from "react";
import { TooltipWithButtonLauncher } from "../Generic/TooltipWrapper";
import CustomComponent from "./CustomComponent";

/**
 * A `<terriatooltip>` custom component, taking a title and content
 * around its child components. It has the following attributes:
 *
 *   * `title` - (Required) The text to use as the "tooltip launcher"
 */
export default class TerriaTooltipCustomComponent extends CustomComponent {
  get name() {
    return "terriatooltip";
  }
  get attributes() {
    return ["title"];
  }
  processNode(_context, node, children) {
    /* eslint-disable-next-line react/no-children-prop */
    return /*#__PURE__*/createElement(TooltipWithButtonLauncher, {
      dismissOnLeave: true,
      launcherComponent: () => {
        var _node$attribs;
        return (_node$attribs = node.attribs) === null || _node$attribs === void 0 ? void 0 : _node$attribs.title;
      },
      children: () => children
    });
  }
}